import { FormikErrors } from "formik";

export const scrollToFirstError = <T>(
  errors: FormikErrors<T>,
  touched: Record<string, boolean>
) => {
  const firstErrorKey = Object.keys(errors).find((key) => touched[key]);

  if (!firstErrorKey) return;

  const errorElement =
    document.querySelector(`[name="${firstErrorKey}"]`) ||
    document.getElementById(firstErrorKey) ||
    document.querySelector('[aria-invalid="true"]');

  if (errorElement) {
    errorElement.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    setTimeout(() => {
      (errorElement as HTMLElement).focus();
    }, 100);
  }
};
